export const looksLikeHtmlDocument = (value: unknown): value is string => {
  if (typeof value !== 'string') {
    return false
  }
  const trimmed = value.trimStart().toLowerCase()
  return trimmed.startsWith('<!doctype html') || trimmed.startsWith('<html')
}
